import { Link } from "react-router-dom";
import { GraduationCap, BookOpen, Clock } from "lucide-react";
import { ACADEMY_COURSES, IMAGES } from "@/data/content";
import { Reveal, Eyebrow, SectionTitle } from "@/components/common";

const LEVEL_COLOR = { Introductory: "#D9B382", Intermediate: "#D4AF37", Reflective: "#C85A32" };

export default function Learn() {
  return (
    <div className="pt-16 lg:pt-[72px]" data-testid="learn-page">
      <section className="relative py-20 lg:py-28 border-b border-indic-gold/15">
        <img src={IMAGES.buddhaStone} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1021]/80 to-indic-indigo" />
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-8">
          <span className="inline-flex items-center gap-2 text-indic-gold"><GraduationCap size={20} /><Eyebrow>INDIC Academy</Eyebrow></span>
          <h1 className="mt-4 font-serif text-5xl lg:text-6xl font-semibold text-amber-50">Learn the civilisation</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-300/90 leading-relaxed">
            Structured learning paths that turn the library into a curriculum — from first foundations to reflective close reading. Each path draws directly on the texts.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
          <Reveal><SectionTitle eyebrow="Learning Paths" title="Six guided courses" /></Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ACADEMY_COURSES.map((c, i) => (
              <Reveal key={c.title} delay={(i % 3) * 0.07}>
                <div className="flex flex-col h-full rounded-sm border border-indic-card-border bg-indic-card p-6 hover:border-indic-gold/40 transition-colors" data-testid={`course-${i}`}>
                  <span className="text-xs font-sans uppercase tracking-wider" style={{ color: LEVEL_COLOR[c.level] }}>{c.level}</span>
                  <h3 className="mt-2 font-serif text-2xl text-amber-50">{c.title}</h3>
                  <p className="mt-3 text-sm text-slate-300/85 leading-relaxed flex-1">{c.desc}</p>
                  <div className="mt-5 flex items-center justify-between border-t border-indic-card-border pt-4">
                    <span className="inline-flex items-center gap-1.5 text-xs text-slate-400"><Clock size={13} /> {c.lessons} lessons</span>
                    <Link to={`/library/${c.work}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-indic-gold hover:text-indic-gold-soft" data-testid={`course-start-${i}`}><BookOpen size={14} /> Begin</Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
